var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading75_container"},[_c('div',{staticClass:"loading"},[_c('svg',{attrs:{"height":"48px","width":"64px"}},[_c('polyline',{attrs:{"id":"back","points":"0.157 23.954, 14 23.954, 21.843 48, 43 0, 50 24, 64 24"}}),_c('polyline',{attrs:{"id":"front","points":"0.157 23.954, 14 23.954, 21.843 48, 43 0, 50 24, 64 24"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }